import React, { useEffect, useState } from "react";
import AccountSwitcher from "./AccountSwitcher";
import { getAllChildren, handleChildLogin, handleSwitchProfile } from "../../../Profile/api";
import { setUserInfo } from "../../../Redux/UserInfo/actions";
import { useDispatch } from "react-redux";
import Loader from "../../../CommonComponents/Loader/Loader";
import useChildUserDetails from "../../../CustomHooks/useChildUserDetails";
import { setChildUserInfo } from "../../../Redux/ChildUserInfo/actions";
import useAllUserData from "../../../CustomHooks/useAllUserData";
import { titleCase } from "../../../CommonFunctions/Function";

const ProfileSwitch = (props) => {
  const { userLoggedIn, userDetails, childrenData, setChildrenData } = props;

  // const entityDetails = JSON.parse(localStorage.getItem("parentData"));

  const allUserData = useAllUserData() || {};
  const { entityDetails = [] } = allUserData || {};

  // const { member: parentUserData = {} } = entityDetails || {};
  const [isLoading, setIsLoading] = useState(false);
  // const [profileUser, setProfileUser] = useState("");

  const dispatch = useDispatch();

  const [userProfiles, setUserProfiles] = useState([
   
  ]);

  // let childrenProfiles = childrenData.map((child) => {
  //   return {
  //     name: `${child?.first_name} ${child?.last_name ?? ""}`,
  //     selected: child?.id === userDetails.id,
  //     id: child?.id,
  //     gstState: child?.gstState ? child?.gstState : "",
  //   };
  // });

  useEffect(() => {
    if (entityDetails?.length) {
      const profilesArray = [];
        entityDetails.forEach(element => {
          profilesArray.push(
            {
            name: `${element?.entityDetail?.basicInfo?.firstName} ${element?.entityDetail?.basicInfo?.lastName ?? ""}`,
            selected: element?.entityDetail?.entityId === userDetails.atms_id,
            id: element?.entityDetail?.entityId,
            gstState: element?.entityDetail?.gstStateName ? titleCase(element?.entityDetail?.gstStateName):"",
          });
        });
       
      setUserProfiles(profilesArray);
    }
  }, [entityDetails]);

  const selectOptionFun = (profileId) => {
    setIsLoading(true);

    setUserProfiles((prev) => {
      const profilesArray = prev;

      const newArray = profilesArray.map((profile) => {
        if (profile?.id === profileId.id) {
          return { ...profile, selected: true };
        } else {
          return { ...profile, selected: false };
        }
      });
      return newArray;
    });

    handleSwitchProfile({
      id: profileId.id,
    })
      .then((resp) => {
        setIsLoading(false);
        if (resp && resp?.data && resp?.data?.token) {
          let result = resp;
          localStorage.setItem("authToken", result.data.token);
          localStorage.setItem(
            "userDashBoardData",
            JSON.stringify(result.data)
          );
          localStorage.setItem("notifications", JSON.stringify(result.data));
          localStorage.setItem(
            "userDashBoardDataplan",
            JSON.stringify(result.data.userPlan)
          );
          if (
            result?.data?.role_name &&
            result.data?.member?.roles[0].name === result.data.role_name
          ) {
            localStorage.setItem("isOtherUser", "isOtherUser");
          }
          localStorage.setItem(
            "disbrusementPopup",
            result.data.disbursementPopUp
          );
          localStorage.setItem("LacPopup", result.data.LacPopup);
          localStorage.setItem("aryauserType", result.data.member.roles[0].id);
          localStorage.setItem("isKyc", result.data.member.kyc);
          localStorage.setItem("isParent", result.data.member.parent_id);
          localStorage.setItem("user_type", result.data.user_type);

          localStorage.setItem("rms_expire", result.data.rms_expire);
          localStorage.setItem("rms_token", result.data.rms_token);
          localStorage.setItem("rms_user", result.data.rms_user);
          localStorage.setItem("cookies_url", result.data.cookie);

          dispatch(
            setUserInfo({
              ...(result.data?.member || {}),
              permissions: result.data?.permissions,
              userData: result.data,
              userLoggedIn: true,
            })
          );
          window.location.reload();
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };
  return (
    <>
      <Loader isLoading={isLoading} />
      <AccountSwitcher
        profileUserOption={userProfiles}
        selectOptionFun={selectOptionFun}
      />
    </>
  );
};
export default ProfileSwitch;
